import React from "react";

const Clone = ({ color = "#0FADAD", width = 28, height = 28 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15.8996" cy="8" r="7.25" stroke={color} strokeWidth="1.5" />
    <circle cx="8.43365" cy="8" r="7.25" fill={color} stroke={color} strokeWidth="1.5" />
  </svg>
);

export default Clone;
